import { useState } from "react";
import { Upload } from "lucide-react";
import ExpenseRegisterView from "./ExpenseRegisterView";
import RegistersView from "./RegistersView";
import PerplexityView from "./PerplexityView";
import DocumentsView from "./DocumentsView";

const SUB_TABS = [
  { id: "expenses", label: "Expenses" },
  { id: "registers", label: "Registers" },
  { id: "spaces", label: "Spaces" },
];

function SubTabs({ active, setActive }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200/70 p-1 inline-flex gap-1">
      {SUB_TABS.map((tab) => {
        const on = active === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => setActive(tab.id)}
            className={`px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors ${
              on
                ? "bg-[#1B3A5C] text-white"
                : "text-slate-600 hover:bg-slate-100"
            }`}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}

export default function ListsView() {
  const [subView, setSubView] = useState("expenses");
  const [uploading, setUploading] = useState(false);

  if (uploading) {
    return <DocumentsView onBack={() => setUploading(false)} />;
  }

  return (
    <div>
      <div className="flex items-center justify-between gap-3 mb-4 px-1">
        <h2 className="text-lg font-semibold text-slate-900 tracking-tight">
          Lists
        </h2>
        <button
          onClick={() => setUploading(true)}
          className="inline-flex items-center gap-1.5 text-sm bg-[#1B3A5C] hover:bg-[#0E243B] text-white px-3 py-1.5 rounded-lg font-medium transition-colors shrink-0"
        >
          <Upload size={16} strokeWidth={2.25} />
          <span className="hidden sm:inline">Upload document</span>
          <span className="sm:hidden">Upload</span>
        </button>
      </div>

      <div className="mb-4 -mx-1 px-1 overflow-x-auto">
        <SubTabs active={subView} setActive={setSubView} />
      </div>

      {subView === "expenses" && <ExpenseRegisterView />}
      {subView === "registers" && <RegistersView />}
      {subView === "spaces" && <PerplexityView />}
    </div>
  );
}
